import { useState, createContext, useContext, useMemo } from 'react';
import { UserType } from '../db/Orm';
import axios from 'axios';
import API from '../api/API';
import Cookies from 'js-cookie';

interface AuthContextType {
    user: UserType | null;
    token: string;
    isAuthenticated: boolean;
    hasPermission: (perm: string) => boolean;
    signin: (cpf: string, password: string, onError: Function, onError2: Function, callback: VoidFunction) => void;
    signout: (callback: VoidFunction) => void;
    verifyCookies: (token_invalid: boolean, callback: VoidFunction) => void
}

export const AuthContext = createContext<AuthContextType>(null!)
export const AuthProvider = ({ children }: { children: React.ReactNode }) => {
    const [user, setUser] = useState<UserType | null>(null);
    const [token, setToken] = useState<string>('');
    const signin = async (cpf: string, password: string, onError: Function, onError2: Function, callback: VoidFunction) => {
        try {
            const response = await axios.post(API.url + 'token/', { username: cpf.replaceAll(".", "").replaceAll("-", "").replace('/', ''), password: password });

            const data = response.data
            if (data?.access) {
                setUser(data.user);
                setToken(data.access);
                Cookies.set('token', data.access)
                Cookies.set('cpf_cnpj', data.user)
                callback();
            }
        } catch (e: any) {
            console.log('Erro:', e.response?.data || e.message);
            // Tratamento de erros vindo do servidor (400, 401, etc)
            if (e.response) {
                const data = e.response.data;

                if (data.detail) return onError("Credenciais inválidas!");
                if (data.password) return onError("Senha em branco!");
                if (data.username) return onError2("CPF em branco!");

                onError("Erro ao processar login.");
            }
            else {
                // Erro de rede ou servidor offline
                onError("Erro na conexão com o servidor!");
            }

        }
    }
    let signout = (callback: VoidFunction) => {
        Auth.signout(callback);
    };
    let hasPermission = (perm: string) => {
        if (!user?.permissions || user.permissions.length === 0) return false;
        for (const sp of perm.split(',')) {
            for (const p of user.permissions) {
                if (p === sp) {
                    return true;
                }
            }
        }
        return false
    }
    const verifyCookies = async (token_invalid: boolean, callback: VoidFunction) => {
        if (!token_invalid) {
            const token = Cookies.get('token')
            if (token) {
                setToken(token);
                const cpf_cnpj = Cookies.get('cpf_cnpj')
                if (cpf_cnpj) {
                    const users = (await API.getUser(cpf_cnpj, null, () => { console.log('Erro na conexão com servidor!') })) as Array<UserType>;
                    users?.[0] && setUser(users[0])
                    callback()
                }
            }
        }
    }
    const value = useMemo(() => ({ user, token, isAuthenticated: !!user, hasPermission, signin, signout, verifyCookies }), [user, token]);
    return <AuthContext.Provider value={value} > {children}</AuthContext.Provider >;
}
const Auth = {
    useAuth() {
        return useContext(AuthContext)
    },
    getHeader(multipart?: boolean) {
        var headers = new Headers();
        const token = Cookies.get('token')
        headers.append('Authorization', 'Bearer ' + token);
        if (!multipart)
            headers.append('Content-Type', 'application/json');
        return headers;
    },
    signout(callback: VoidFunction) {
        Cookies.remove('token');
        Cookies.remove('cpf_cnpj');
        callback();
    },
}
export default Auth;